<article class="content">
	<stages-round-progress
		[step]="step"
		[currentStepNr]="currentStepNr"
		[amountOfSteps]="amountOfSteps"
		[progress]="progress"
		[remainingTimeMillis]="remainingTimeMillis"
		[finalState]="finalState"
	>
	</stages-round-progress>

	<ng-container *ngIf="!finalState && step?.messageKey === null">
		<p class="centered-text">
			<span *ngIf="isWaiting" translate="progress.waiting"></span>
			<span *ngIf="!isWaiting" translate="{{ messageKeyPrefix }}.progress"></span>
		</p>
		<p *ngIf="retryIfFailed && lastExecutionFailed" class="centered-text">
			<span
				*ngIf="isWaiting"
				translate="progress.nextAttempt.waiting"
				[translateParams]="{ attempts: attempts + 1, maxAttempts: maxAttempts, startTime: nextExecutionTime }"
			></span>
			<span
				*ngIf="!isWaiting"
				translate="progress.nextAttempt.running"
				[translateParams]="{ attempts: attempts, maxAttempts: maxAttempts }"
			></span>
		</p>
	</ng-container>

	<p *ngIf="finalState === 'success'" class="centered-text" translate="{{ messageKeyPrefix }}.{{ finalState }}"></p>

	<div class="operation-result-outer">
		<div class="operation-result warning-color" *ngIf="finalState === 'warnings'">
			<i class="ico ico-warning warning-color"></i>
			<p>
				<span translate="{{ messageKeyPrefix }}.{{ finalState }}"></span>&nbsp;
				<a
					class="warning-color clickable"
					[translate]="warningsMessageKey"
					[translateParams]="{ length: warnings.length }"
					(click)="next.emit()"
				></a>
			</p>
		</div>

		<div class="operation-result error-color" *ngIf="finalState === 'failure'">
			<i class="ico ico-warning error-color"></i>
			<div>
				<p>
					<strong class="error-color" translate="{{ messageKeyPrefix }}.{{ finalState }}"></strong>
				</p>
				<p>{{ error }}</p>
				<p>{{ "progress.error.incidentid" | translate }}:{{ incidentId }}</p>
			</div>
		</div>
	</div>
</article>
<footer>
	<stages-buttons-bottom [removeBoundaries]="isPopup">
		<div class="spacer"></div>
		<button type="button" class="button lg cancel" (click)="closed.emit()" *ngIf="hasWarnings() && !download">
			<span translate="progress.later"></span>
		</button>
		<button type="button" class="button lg cancel" (click)="stopped.emit()" *ngIf="!finalState && stoppable">
			<span translate="stop"></span>
		</button>
		<a
			[href]="download"
			role="button"
			class="button lg cancel"
			(click)="closed.emit()"
			*ngIf="hasWarnings() && download"
		>
			<span translate="download"></span>
		</a>
		<button type="button" class="button lg next" (click)="next.emit()" *ngIf="hasWarnings()">
			<span translate="progress.summary"></span>
		</button>
		<button
			type="button"
			class="lg next"
			(click)="closed.emit()"
			*ngIf="!hasWarnings() && resumable && hasNextButton"
			[disabled]="nextDisabled"
		>
			<span translate="continue"></span>
		</button>
		<a
			role="button"
			class="button lg next"
			[href]="download"
			(click)="closed.emit()"
			*ngIf="!hasWarnings() && download"
			[class.disabled]="nextDisabled ? true : null"
		>
			<span translate="download"></span>
		</a>
	</stages-buttons-bottom>
</footer>
